import React, { Component } from 'react';
import './App.css';

import PropTypes, { bool, string } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";
import _, { split } from 'lodash';
import { withSnackbar } from 'notistack';
import qs from "qs";
import FormGroup from "@material-ui/core/FormGroup";
import readXlsxFile from 'read-excel-file'
import Input from '@material-ui/core/Input';
import { InputLabel } from '@material-ui/core'
import { MenuItem } from '@material-ui/core'
import { FormControl, Select } from '@material-ui/core';
import axios from "axios";
import ReactTable from 'react-table';
import "react-table/react-table.css";
import MUIDataTable from 'mui-datatables';
import { urlConfig } from './config'

const styles = theme => ({
    container: {
        position: 'relative',
    },
});


class FileGeneration extends Component {

    constructor(props) {
        super(props);
        let parsed = qs.parse(this.props.location.search);

        let cidInputValue = "";
        let task = "";
        let cidValueType = null;



        if (parsed["cidInputValue"] && parsed["cidInputValue"].length > 0) {
            cidValueType = "input"
            cidInputValue = parsed["cidInputValue"];
        }


        if (parsed["?task"] && parsed["?task"].length > 0) {
            task = parsed["?task"];
        }

        this.state = {
            task: "", responseData: null, isloading: false, isError: false, fileError: false, cidTextError: false, cidInputValue, cidFileValue: "", cidValueType, cidInputValueErrMsg: "Max limit of CIDs allowed are 5, min length of each CIDs is 3 and max length is 15 and CID value should not be null, empty, will not allow any special characters and duplicate values.", cidFileValueErrMsg: ""
        };
    }

    handleChange = event => {
        const { name, value } = event.target

        if (name === "task") {
            this.setState({
                [name]: value,
                isError: false,
                responseData: null
            });
        }
        else {
            const resultArray=value.split(",")
            if (value.split(',').length <= 5) {
                const res = resultArray.filter(item => (item !== null && item !== "" && String(item).match(/^[0-9]{5,15}$/)))
                if (res.length == resultArray.length) {      
                    var set = new Set(resultArray)
                    if (set.size == resultArray.length) {
                        this.setState({
                            [name]: value,
                            isError: false,
                            cidValueType: "input",
                            cidFileValue: "",
                            responseData: null,
                            fileError: false,
                            cidTextError: false
            
                        });
                        return

                    }
                }
            }
            this.setState({
                [name]: value,
                isError: false,
                cidValueType: null,
                cidFileValue: "",
                responseData: null,
                fileError: false,
                cidTextError: true

            });
           
            document.getElementById("cidFileValue").value = ""
        }

    };


    fileProcessGeneration = async (event) => {
        try {
            console.log(this.state);
            event.preventDefault();
            this.setState({
                isloading: true,
                isError: false,
                responseData: null
            })
            const { cidFileValue, cidValueType, cidInputValue, task } = this.state
            {
                const { data } = await axios.post(`${urlConfig.bffUrl}/videoGeneration/listOfCids`,
                    {
                        cids: cidValueType === "file" ? cidFileValue : cidInputValue,
                        task,
                        userEmail: sessionStorage.getItem("userEmail")
                    }
                )
                document.getElementById("cidFileValue").value = "";

                console.log(data);
                this.setState({
                    responseData: data,
                    isloading: false,
                    cidInputValue:'',
                    task :'',
                })

            }
        }
        catch (error) {
            this.setState({
                isloading: false,
                isError: true
            })
        }

    }

    render() {
        const { responseData, isloading, isError, task, cidFileValue, cidValueType, cidInputValue, cidFileValueErrMsg, cidInputValueErrMsg, cidTextError } = this.state
        const { classes, theme } = this.props
        const Loader = () => {
            return (<div className='loader-wrapper'>
                <div class="loader"></div>
                <p>Processing...</p>
            </div>)
        }
        const columns = [
            {
                label: "CID",
                name: "cid"
            },
            {
                label: 'Message ID',
                name: "message_id"
            }
        ]
        const options = {
            filterType: 'textField',
            pagination: true,
            selectableRows: 'none',
            print: false,
            viewColumns: false,
            responsive: 'stacked',
            search: false,
            download: false,
            filter: false

        };
        const onFileUpload = (event) => {
            //console.log(event.target.value[0].files[0].name);
            console.log(event.target.files);

            if (!event.target.files.length) {
                this.setState({
                    fileError: true,
                    cidFileValueErrMsg: "please upload csv file",
                    cidFileValue: "",
                    isError: false,
                    responseData: null,
                    cidValueType: "file",
                    cidInputValue: "",
                    cidTextError: false
                })
                return
            }

            const uploadedFile = event.target.files[0]
            console.log(uploadedFile);
            this.setState({ fileName: uploadedFile.name })
            const reader = new FileReader();

            // Event listener on reader when the file
            // loads, we parse it and set the data.
            reader.onerror = () => {

                this.setState({
                    fileError: true,
                    cidFileValue: "",
                    isError: false,
                    responseData: null,
                    cidFileValueErrMsg: "Please upload valid csv file"
                })
                console.log("has error");

            }
            reader.onload = async ({ target }) => {
                const { result } = target
                console.log(result.split(","));
                const resultArray = result.split(",")
               
                
                if (result.split(',').length <= 50) {
                    const res = resultArray.filter(item => (item !== null && item !== "" && String(item).match(/^[0-9]{5,15}$/)))
                    if (res.length == resultArray.length) {
                        
                        var set = new Set(resultArray)
                        if (set.size == resultArray.length) {
                            this.setState({
                                fileError: false,
                                cidTextError: false,
                                cidFileValue: result,
                                isError: false,
                                cidValueType: "file",
                                cidInputValue: "",
                                responseData: null
                            })
                            return

                        }
                    }
                }

                this.setState({
                    fileError: true,
                    cidFileValue: "",
                    cidTextError: false,
                    cidValueType: "file",
                    cidInputValue: "",
                    isError: false,
                    responseData: null,
                    cidFileValueErrMsg: "Max limit of CIDs allowed are 50, min length of each CIDs is 3 and max length is 15 and CID value should not be null, empty, will not allow any special characters and duplicate values."
                })




            }

            reader.readAsText(uploadedFile)

        }

        console.log(responseData)
        return <React.Fragment>

            <Paper>
                <React.Fragment>
                    <Grid spacing={0}
                        container
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center">
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            <form onSubmit={this.fileProcessGeneration}>
                                <FormGroup row>
                                    <Grid spacing={2}
                                        container
                                        direction="row"
                                        justifyContent="flex-start"
                                        alignItems="center">

                                        <Grid item style={{ display: "flex", flexDirection: "column" }}>
                                            <Grid item style={{ marginRight: "20px", display: "flex", alignItems: "center" }}>
                                                <Grid>
                                                    <label htmlFor="contained-button-file">

                                                        <Input inputProps={{ style: { cursor: 'none' }, accept: "text/csv", id: "cidFileValue" }} id="contained-button-file" type="file"
                                                            onChange={onFileUpload}
                                                        />
                                                        {/* <Button variant="contained" component="span" color="primary">
                                                        Upload
                                                    </Button> */}
                                                    </label>
                                                    {this.state.fileError &&
                                                        <p style={{ color: "red" }}>{cidFileValueErrMsg}</p>
                                                    }
                                                </Grid>
                                                <label style={{ margin: "0 1rem" }}>or</label>
                                                <Grid item xs={7}>
                                                    <TextField
                                                        id="outlined-cid"
                                                        label="CID"
                                                        onChange={this.handleChange}
                                                        name="cidInputValue"
                                                        margin="normal"
                                                        variant="outlined"
                                                        fullWidth
                                                        value={cidInputValue}

                                                    />
                                                    {cidTextError &&
                                                        <p style={{ color: "red" }}>{cidInputValueErrMsg}</p>
                                                    }
                                                </Grid>

                                            </Grid>
                                            <Grid container alignItems='center' spacing={3}>
                                                <Grid item xs={5}>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">task</InputLabel>
                                                        <Select required autoComplete='off'
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            value={task}
                                                            label="Filter by" name='task'
                                                            onChange={this.handleChange}
                                                        >
                                                            <MenuItem value={'LOW_RES'}>LOW_RES</MenuItem>
                                                            <MenuItem value={'HIGH_RES'}>HIGH_RES</MenuItem>

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                            <Grid item style={{ marginTop: "2rem", marginBottom: "2rem" }}>
                                                {(cidValueType !== null && ((cidValueType === "input" && cidInputValue !== "") || (cidValueType === "file" && cidFileValue !== "")) && task !== '') ?
                                                    <Button variant="contained" color="primary" type="submit">
                                                        Submit
                                                    </Button>
                                                    : null}
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                </FormGroup>
                            </form>
                            <style jsx="true">
                                {`
                                .loader {
                                    border:8px solid #f3f3f3; /* Light grey */
                                border-top: 8px solid #ffbf00; /* Blue */
                                border-radius: 50%;
                                width: 50px;
                                height: 50px;
                                animation: spin 2s linear infinite;
                                }
                               .loader-wrapper{
                                display:flex;
                                justify-content:center;
                                align-items: center;
                                flex-direction: column;
                                margin-top:1rem;
                                }

                                @keyframes spin {
                                    0 % { transform: rotate(0deg); }
                                    100% {transform: rotate(360deg); }
                                }`}
                            </style>
                            {isloading ? <Loader /> :

                                <>{isError ? <p style={{ color: "red", fontSize: "1rem" }}>something went wrong please connect with CMS team </p>
                                 : (responseData && !this.state.fileError) &&
                                   <p style={{fontSize:"1rem" ,fontWeight:"bold"}}>Request for Low or High resolution video has been submitted, please check respective storage folders in sometime.</p>
                                    }</>
                            }
                            <br />

                        </Grid>
                    </Grid>
                </React.Fragment>
            </Paper >

        </React.Fragment >
    }
}


FileGeneration.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar((withStyles(styles, { withTheme: true })(FileGeneration)));
